import styled from 'styled-components';
import dobInputStyles from '../../styles/dobInputStyles';
var InputYear = styled.input.withConfig({
  displayName: "InputYear",
  componentId: "pjgt4o-0"
})(["", " flex:1 1 auto;padding-left:0.5rem;padding-right:0.625rem;text-align:left;&::-ms-clear{display:none;}"], dobInputStyles);
export default InputYear;